import { inject, Injectable } from "@angular/core";
import { createEffect, ofType, Actions } from "@ngrx/effects";
import { map, catchError, of, switchMap } from "rxjs";
import { RoleService } from "../../services/role/role.service";
import { RoleLookupActions } from "./roles.actions";
import { IRoleLookup } from "./roles.state";

@Injectable()
export class RoleLookupEffects {
  private actions$ = inject(Actions);
  private roleService = inject(RoleService);

  loadRoles$ = createEffect(() => this.actions$.pipe(
      ofType(RoleLookupActions.loadRoles),
      switchMap((_) => {
        return this.roleService.getAllRoles().pipe(
          map(roles => {
            return RoleLookupActions.loadRolesSuccess({roles: ((roles as any)["data"] as IRoleLookup[])})
        }),
          catchError(error => of(RoleLookupActions.loadRolesFailure({ error })))
        );
      })
    )
  );

  loadCopilotRoles$ = createEffect(() => this.actions$.pipe(
      ofType(RoleLookupActions.loadCopilotRoles),
      switchMap(() => this.roleService.getCopilotRoles().pipe(
          map(roles => RoleLookupActions.loadCopilotRolesSuccess({ roles })),
          catchError(error => of(RoleLookupActions.loadCopilotRolesFailure({ error })))
      ))
  ));
}
